<template>
    <div class="modal-body">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
            <label class="form-label">Title</label>
            <div class="input-group input-group-merge w-100">
                <input
                    name="name"
                    type="text"
                    class="form-control"
                    placeholder="Enter Title"
                    v-model="formData.title"
                />
            </div>
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
            <label class="form-label">Date & Time</label>
            <div class="input-group input-group-merge w-100">
                <input
                    name="datetime"
                    type="datetime-local"
                    class="form-control"
                    v-model="formData.start_time"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
                <label class="form-label">Assign To</label>
                <AsyncSelect
                      placeholder="Assign To"
                      :disabled="isCreator"
                      v-model="formData.assign_to"
                      :api-service="fetchContactProfiles"
                      :additional-query="{roles: 'employee', status: 'active'}"
                      label="name"
                />
            </div>
            <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
                <label class="form-label">Report To</label>
                  <AsyncSelect
                      placeholder="Report To"
                      :disabled="isCreator"
                      v-model="formData.report_to"
                      :api-service="fetchContactProfiles"
                      :additional-query="{roles: 'employee', status: 'active'}"
                      label="name"
                  />
            </div>
        </div>

        <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
            <label for="colFormLabel" class="col-form-label">Participants </label>
                <AsyncSelect
                    multiple
                    :disabled="isParticipant"
                    placeholder="Select participants"
                    v-model="formData.participants"
                    :api-service="fetchContactProfiles"
                    :additional-query="{roles: 'employee', status: 'active'}"
                    label="name"
                />
        </div>

        <div class="row justify-content-end">
            <div class="col-4 btn-margin text-right">
              <button class="btn btn-outline-primary" @click="isMoreSelected = !isMoreSelected">
                {{ isMoreSelected ? 'Less Options' : 'More Options' }}
              </button>
            </div>
        </div>

        <div v-if="isMoreSelected">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                <label class="form-label">Organization Activity</label>
                  <AsyncSelect
                      multiple
                      :disabled="isParticipant"
                      placeholder="Select Activity"
                      v-model="formData.or_activity"
                      :api-service="fetchActivitySetupEndpoint"
                      label="name"
                  />
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                <label for="colFormLabel" class="col-form-label"> Deal </label>
                    <AsyncSelect
                        placeholder="Select Deal"
                        v-model="formData.deal"
                        :api-service="fetchDealNameList"
                        label="name"
                        :disabled="isFromDeal"
                    />
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                <label class="form-label">Client</label>
                  <AsyncSelect
                      placeholder="Client"
                      v-model="formData.client"
                      :disabled="isParticipant || isFromDeal"
                      :api-service="fetchContactProfiles"
                      :additional-query="{roles: 'customer,lead'}"
                      @option:selected="onChangeSelectedClient"
                      label="name"
                  />
            </div>

            <div class="row">
                <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
                    <label class="form-label">Project</label>
                      <AsyncSelect
                          placeholder="Select Project"
                          :disabled="isParticipant"
                          v-model="formData.project"
                          :api-service="fetchProjects"
                          label="name"
                          @option:selected="onChangeSelectedProject"
                          ref="projectDropdown"
                          :additional-query="{ with_donors: 1, party_id: formData.client && formData.client.id }"
                      />
                </div>
                <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
                    <label class="form-label">Project Activity</label>
                    <AsyncSelect
                        placeholder="Select Project Activity"
                        v-model="formData.project_activity"
                        :disabled="isParticipant"
                        :api-service="fetchProjectActivity"
                        ref="projectActivityDropdown"
                        label="name"
                        :additional-query="{ project_id: formData.project && formData.project.id }"
                    />
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                <label class="form-label">Tag</label>
                <v-select
                    multiple
                    placeholder="Select Tag"
                    :disabled="isParticipant"
                    v-model="formData.tag"
                    :options="tagList"
                    label="name"
                />
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                <label class="form-label">Priority</label>
                <v-select
                    placeholder="Select Priority"
                    v-model="formData.priority"
                    :disabled="isParticipant"
                    :options="priorityList"
                    label="name"
                />
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                <label class="form-label">Description</label>
                <div class="input-group input-group-merge w-100">
                    <textarea
                        :disabled="isParticipant"
                        v-model="formData.description"
                        name="reference" rows="2"
                        placeholder="Enter Description"
                        class="form-control add-credit-card-mask"
                    >
                    </textarea>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                <label class="form-label">Attachment</label>
                <BlobFileViewer :attachments="formData.attachments" />
                <FileUpload
                    :is-drag-active="true"
                    button-text="Upload Documents"
                    v-model="formData.attachments"
                >
                </FileUpload>
            </div>
        </div>

        <div v-if="isWorkStatusForm">
          <hr>
          <h4 class="fw-bolder">My Work Status</h4>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-8 mb-1">
              <label class="form-label">Description</label>
              <div class="input-group input-group-merge w-100">
                    <textarea
                        v-model="workStatusFormData.description"
                        name="reference" rows="2"
                        placeholder="Enter Description"
                        class="form-control add-credit-card-mask"
                    >
                    </textarea>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-4 mb-1">
              <label class="form-label">Input Hours</label>
              <input
                  name="name"
                  type="text"
                  class="form-control"
                  placeholder="Enter Hours"
                  v-model="workStatusFormData.hours"
              />
            </div>

             <div class="col-12 col-sm-12 col-md-4 mb-1">
              <label class="form-label">Location</label>
              <AsyncSelect
                  placeholder="Select Location"
                  v-model="workStatusFormData.area_id"
                  :api-service="fetchAreaList"
                  label="label"
                  @option:selected="handleLocationChange"
              />
            </div>

            <div class="col-12 col-sm-12 col-md-4 mb-1">
              <label class="form-label">Conveyance Bill</label>
              <input
                  name="name"
                  type="text"
                  class="form-control"
                  placeholder="Enter Conveyance Bill"
                  v-model="workStatusFormData.conveyance"
              />
            </div>

            <div class="col-12 col-sm-12 col-md-4 mb-1">
              <label class="form-label">Date</label>
              <input
                  name="name"
                  type="date"
                  class="form-control"
                  placeholder="Enter Date"
                  v-model="workStatusFormData.date"
              />
            </div>
          </div>
      </div>

    </div>
</template>

<script setup>
import {ref, reactive, onMounted} from 'vue';
import { getCurrentDateTime } from '@/services/utils/global.js';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from '@/services/modules/contact'
import handleDropDowns from '@/services/modules/dropdowns'
import {useRoute} from "vue-router";
import FileUpload from "@/components/atom/FileUpload";
import BlobFileViewer from "@/components/atom/BlobFileViewer";
import handleProjects from "@/services/modules/procurement/project";
import handleCrm from '@/services/modules/crm/crm'
import handleAdmin from '@/services/modules/admin/admin';
import useDate from '@/services/utils/day';

const {fetchContactProfiles} = handleContact()
const { fetchActivitySetupEndpoint } = handleDropDowns();
const { fetchProjectActivity, fetchProjects} = handleProjects();
const { fetchAreaList, fetchSingleArea } = handleCrm();
const { fetchDealNameList } = handleAdmin();
const { formatToDate } = useDate();

const projectActivityDropdown = ref(null)
const projectDropdown = ref(null)
const props = defineProps({
    startDate: String,
    tagList: Array,
    editData: {
      type:Object,
      default: {}
    },
    taskStatus: {
      type:Object,
      default: {}
    },
    workStatus: {
      type:Object,
      default: {}
    },
    markAsDoneShow:{
      type:Boolean,
      default: false
    },
    isCompleted:{
      type:Boolean,
      default: false
    },
    dealId: {
      type: Number,
      default: null
    },
    dealCustomer: {
        type: Object,
        required: true
    },
    dealData: {
      type: Object,
      default: {}
    },
    isFromDeal: {
      type: Boolean,
      default: false
    },
    priorityList: Array
});

const route = useRoute();

const markDoneFormData = reactive({
  id:null,
})

const workStatusFormData = reactive({
  id:null,
  area_id: null,
  conveyance: null,
  hours: null,
  date: null,
  description: null
})

const formData = reactive({
    type: 'task',
    assign_to: null,
    report_to: null,
    or_activity: [],
    client: '',
    project: '',
    project_activity: '',
    tag: [],
    priority: null,
    start_time: getCurrentDateTime(props.startDate),
    title: '',
    deal: '',
    description: '',
    attachments: [],
    participants: [],
    route_name:'task-calendar'
});

const resetForm = () => {
  formData.title = '';
  formData.start_time = null
  formData.description = '';
  formData.assign_to = null;
  formData.report_to = null;
  formData.client = '';
  formData.project = '';
  formData.deal = '';
  formData.project_activity = '';
  formData.priority = null;
  formData.participants = [];
  formData.or_activity = [];
  formData.tag = [];
  formData.attachments = [];
  workStatusFormData.area_id = null;
  workStatusFormData.hours = null;
  workStatusFormData.description = null;
  workStatusFormData.date = null;
  workStatusFormData.conveyance = null;
};

const isMoreSelected = ref(false);
const isCreator = ref(false);
const isParticipant = ref(false);
const isMarkDoneForm = ref(false);
const isWorkStatusForm = ref(false);

function getFormData() {
  return {...formData};
}

function getMarkDoneFormData() {
  return {...markDoneFormData};
}

function getWorkStatusFormData() {
  return {...workStatusFormData};
}

const onChangeSelectedProject = () => {
  formData.project_activity = null;
  projectActivityDropdown.value.clear();
}

const onChangeSelectedClient = () => {
  formData.project_activity = null;
  formData.project = null;
  projectDropdown.value.clear();
}

const handleLocationChange = async (newArea) => {
  if (!newArea || !newArea.id) {
    workStatusFormData.conveyance = 0
    return
  }

  const query = `?company_id=${route.params.companyId}`
  try {
    const area = await fetchSingleArea(newArea.id, query)
    if (area) {
      workStatusFormData.conveyance = area.data.amount
    }
  } catch (error) {
    workStatusFormData.conveyance = 0
  }
}

onMounted(() => {
  if (props.editData && Object.keys(props.editData).length) {
    const valuesMap = {};

    props.editData.values &&  props.editData.values.forEach((val) => {
      const obj = val.field_value
          ? {
            ...val.field_value,
            id: val.field_value_id,
            name: val.field_value.full_name || val.field_value.name || val.field_value.deal_number ||  '',
          }
          : null;

      if (['participant_id', 'activity_setup_id', 'tag_id'].includes(val.field_key)) {
        if (!valuesMap[val.field_key]) valuesMap[val.field_key] = [];
        if (obj) valuesMap[val.field_key].push(obj);
      }
      if (!['participant_id', 'activity_setup_id', 'tag_id'].includes(val.field_key)) {
        valuesMap[val.field_key] = obj;
      }
    });
    
    markDoneFormData.id = props.editData.id;

    formData.id = props.editData.id
    formData.title = props.editData.short_description || '';
    formData.start_time = props.editData.start_time || getCurrentDateTime(props.startDate);
    formData.description = props.editData.full_description || '';
    formData.type = props.editData.type || '';
    formData.assign_to = valuesMap['assigned_to'] || null;
    formData.report_to = valuesMap['report_to'] || null;
    formData.client = valuesMap['client_id'] || '';
    formData.project = valuesMap['project_id'] || '';
    formData.project_activity = valuesMap['project_activity_id'] || '';
    formData.priority = valuesMap['priority_id'] || null;
    formData.participants = valuesMap['participant_id'] || [];
    formData.or_activity = valuesMap['activity_setup_id'] || [];
    formData.tag = valuesMap['tag_id'] || [];
    formData.deal = valuesMap['deal_id'] || '';
    formData.attachments = props.editData.attachments || [];
  }

  if (props.workStatus && Object.keys(props.workStatus).length > 0) {
    isWorkStatusForm.value = true;
    workStatusFormData.id = props.workStatus.id;
    workStatusFormData.area_id = {
      id: props.workStatus.area_id,
      label: props.workStatus.area_label
    };
    workStatusFormData.hours = props.workStatus.hours;
    workStatusFormData.date = formData.start_time ? formatToDate(formData.start_time) 
                                                  : new Date().toISOString().split('T')[0];
    workStatusFormData.description = props.workStatus.description;
    workStatusFormData.conveyance = props.workStatus.conveyance;
  }

  const ts = props.taskStatus || {};

  if (ts && !ts.is_created && Object.keys(ts).length){
    isCreator.value = true;
  }
  if (
      Object.keys(ts).length &&
      ts.participant &&
      !ts.is_created &&
      !ts.report_to &&
      !ts.assigned_to
  ) {
    isParticipant.value = true;
  }
  if (props.isCompleted && !ts.report_to){
    isMarkDoneForm.value = true;
  }
  if(props.dealId){
    formData.deal = {
      id: props.dealId,
      name: props.dealData.name || ''
    }
  }
  if(props.dealCustomer){
    formData.client = {
      id: props.dealCustomer.id,
      name: props.dealCustomer.name || ''
    }
  }
});

defineExpose({
  getFormData,
  getMarkDoneFormData,
  getWorkStatusFormData,
  resetForm
});

</script>

<style scoped> 
.btn-margin {
    margin-right: 20px;
    margin-bottom: 10px;
}
</style>
